<template>
  <div class="element-contatos">
    <b-form-group label="E-mail :">
      <b-input-group
        v-for="(email, key) in value?.emails ?? []"
        :key="'email' + key"
        class="group-emails"
        :size="size"
      >
        <b-form-input
          class="mt-1"
          v-model="value.emails[key].value"
          :state="validateState('emails')"
        ></b-form-input>
        <b-input-group-append class="mt-1">
          <b-button
            v-b-tooltip.hover
            title="Remover e-mail"
            variant="danger"
            class="btn-remove-contato"
            @click="removeContact('emails', key)"
          >
            <font-awesome-icon icon="trash" />
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-button
        v-b-tooltip.hover
        title="Adicionar campo e-mail"
        class="add mt-2"
        size="sm"
        variant="primary"
        @click="addContact('emails')"
      >
        <b-icon icon="plus" aria-hidden="true"></b-icon>
      </b-button>
    </b-form-group>

    <b-form-group label="Telefones :" v-if="renderContacts">
      <Phone
        v-for="(phone, key) in value?.telefones"
        v-model="value.telefones[key]"
        :key="key"
        ref="phone-values"
        @remove="removeContact('telefones', key)"
        :size="size"
      />

      <b-button
        v-b-tooltip.hover
        title="Adicionar campo número"
        class="add mt-2"
        size="sm"
        variant="primary"
        @click="addContact('telefones')"
      >
        <b-icon icon="plus" aria-hidden="true"></b-icon>
      </b-button>
    </b-form-group>

    <b-form-group label="Mídias Sociais :" v-if="renderContacts">
      <SocialNetwork
        v-for="(social_network, key) in value?.redes_sociais"
        v-model="value.redes_sociais[key]"
        :key="key"
        ref="social-networks-values"
        @remove="removeContact('redes_sociais', key)"
        :size="size"
      />
      <b-button
        v-b-tooltip.hover
        title="Adicionar campo Mídias Sociais"
        class="add mt-2"
        size="sm"
        variant="primary"
        @click="addContact('redes_sociais')"
      >
        <b-icon icon="plus" aria-hidden="true"></b-icon>
      </b-button>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { numeric, email, url } from "vuelidate/lib/validators";
import SocialNetwork from "@/components/Form/Contatos/SocialNetwork.vue";
import Phone from "@/components/Form//Contatos/Phone.vue";
import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty";
import { merge } from "lodash";
import { safeArray } from "@/helpers/functions/ArrayHelpers";

export default {
  components: { Phone, SocialNetwork },
  props: {
    value: {
      type: Object,
      default: () => ({
        phones: [],
        emails: [],
        redes_sociais: [],
      }),
    },
    size: {
      type: String,
      default: "",
    },
  },
  mixins: [validationMixin],
  data: () => ({
    renderContacts: true,
  }),
  validations: {
    value: {
      phones: {
        $each: {
          value: {
            numeric,
          },
        },
      },
      emails: {
        $each: {
          value: {
            email,
          },
        },
      },
      redes_sociais: {
        $each: {
          value: {
            url,
          },
        },
      },
    },
  },
  computed: {},
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      let valid = true;
      this.$refs["phone-values"].forEach((value) => {
        valid &= value.isValid();
      });

      this.$refs["social-networks-values"].forEach((value) => {
        valid &= value.isValid();
      });

      this.$v.value.$touch();
      valid &= !this.$v.value.$anyError;

      return valid;
    },
    addContact(type_contact) {
      if (!this.value) {
        this.setSafeContacts();
        return;
      }

      this.value[type_contact].push({ value: "" });

      this.renderContacts = false;
      this.$nextTick(() => {
        this.renderContacts = true;
      });
    },
    removeContact(type_contact, index) {
      this.value[type_contact].splice(index, 1);

      if (this.value[type_contact].length <= 0) {
        this.addContact(type_contact);
      }
    },
    setSafeContacts() {
      const contato = merge(contatos_empty(), this.value);
      this.$emit("input", contato);
    },
  },
  mounted() {
    this.setSafeContacts();
  },
};
</script>
